import { getUserProfileSettings as getUserProfileSettingsRequest } from '../../utils/api/metadata';
import {
  profileSettingsFetching,
  profileSettingsSucceeded,
  profileSettingsFailed,
} from './slice';
import { setAlert } from '../alerts/slice';
import ALERT_TYPES from '../alerts/constants';

export const getUserProfileSettings = () => async (dispatch) => {
  try {
    dispatch(profileSettingsFetching());
    const result = await getUserProfileSettingsRequest();
    dispatch(profileSettingsSucceeded(result.data.model));
  } catch (error) {
    dispatch(setAlert({
      type: ALERT_TYPES.error,
      message: 'Failed to fetch application user profile settings',
    }));
    dispatch(profileSettingsFailed(error.status, error.message));
  }
};
